export interface SimpleStringLookup {
    [key: string]: string | null;
}

export const OT_VERBS: SimpleStringLookup[] = [
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pual",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "pual",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hit",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "nif",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hit",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hit",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "pual",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "pual",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hit",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hof",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hof",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "pual",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hit",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "nif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hof",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hit",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hit",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "nif",
        "vt": "infa",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "perf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "nif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "nif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hsht",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "nif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hit",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "nif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hsht",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hit",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hof",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "nif",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hit",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hit",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hsht",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "hit",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hit",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hsht",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hof",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "infa",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p2",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "nif",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hsht",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hsht",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hof",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hit",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hit",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hsht",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hsht",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hit",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hof",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "pual",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hof",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "infa",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hit",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hit",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hit",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hof",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hof",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hit",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hit",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p2",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p2",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p2",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "pasq",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "pual",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hof",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "nif",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hit",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hsht",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "pual",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "nif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "nif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hsht",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hof",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "infa",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hsht",
        "vt": "perf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pual",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hof",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pual",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "pual",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hof",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hof",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "pual",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hit",
        "vt": "perf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hotp",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hof",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hotp",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "nif",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hit",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hit",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hit",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hit",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "wayq",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hit",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hsht",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hof",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "nit",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hit",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hotp",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "nif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hsht",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "hit",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hit",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hsht",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hsht",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "poal",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hof",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hsht",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hsht",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hit",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hof",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hsht",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hof",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pual",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hof",
        "vt": "perf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "poel",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pual",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hit",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hof",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "nif",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hit",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hsht",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "poel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "nif",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "pual",
        "vt": "perf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "htpo",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hof",
        "vt": "infa",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "pual",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "pual",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "poal",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "tif",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "tif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "htpo",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "tif",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hsht",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "htpo",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hit",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hof",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "nif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hit",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hof",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hof",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "nit",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "pual",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "nif",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hof",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hsht",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "nif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "tif",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "poel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hit",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "nif",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hit",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hit",
        "vt": "wayq",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "hsht",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hit",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "hif",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "hsht",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hof",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "pual",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "etpa",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "poel",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hit",
        "vt": "infa",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "piel",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "nif",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "piel",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hof",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "hit",
        "vt": "wayq",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "poal",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "nif",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hif",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "qal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "piel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "hif",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "hif",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "pual",
        "vt": "wayq",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "htpe",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpe",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "impf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "peal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "perf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpe",
        "vt": "perf",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "etpa",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "peal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpa",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpe",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peil",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "peal",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "haf",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "pael",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "peal",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "peal",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpe",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpe",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "impf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpa",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpa",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpe",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "etpe",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "afel",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "htpe",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "hof",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "shaf",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "haf",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "shaf",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "shaf",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "etpa",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "peil",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpa",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "shaf",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpe",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpa",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "pael",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "haf",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "peal",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "afel",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "pael",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "pael",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "pael",
        "vt": "impv",
        "ps": "p2",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "pael",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "pael",
        "vt": "perf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "pael",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "etpa",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "afel",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "impf",
        "ps": "p1",
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "htpa",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "peil",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpe",
        "vt": "perf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peil",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "haf",
        "vt": "perf",
        "ps": "p1",
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "etpa",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "shaf",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "shaf",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "peal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "shaf",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "pael",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "shaf",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "etpe",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "haf",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "vs": "peal",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "haf",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "vs": "htpa",
        "vt": "impf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "shaf",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpa",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpe",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "shaf",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpe",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "vs": "peal",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "shaf",
        "vt": "perf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "afel",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpa",
        "vt": "perf",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpa",
        "vt": "infc",
        "ps": "unknown",
        "nu": "unknown",
        "gn": "unknown",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pael",
        "vt": "impf",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "htpe",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "haf",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "impf",
        "ps": "p3",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "vs": "pael",
        "vt": "impv",
        "ps": "p2",
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "peal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "pl",
        "gn": "m",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "pual",
        "vt": "ptcp",
        "ps": "unknown",
        "nu": "sg",
        "gn": "m",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "vs": "qal",
        "vt": "wayq",
        "ps": "p3",
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "vs": "qal",
        "vt": "ptca",
        "ps": "unknown",
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    }
];

export const NT_NOUNS: SimpleStringLookup[] = [
    {
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "feminine",
        "degree": null
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "feminine",
        "degree": null
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "masculine",
        "degree": null
    },
    {
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "masculine",
        "degree": null
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "masculine",
        "degree": null
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "masculine",
        "degree": null
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "feminine",
        "degree": null
    },
    {
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "feminine",
        "degree": null
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "masculine",
        "degree": null
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "feminine",
        "degree": null
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "neuter",
        "degree": null
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "neuter",
        "degree": null
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "neuter",
        "degree": null
    },
    {
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": "masculine",
        "degree": null
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": null,
        "degree": null
    },
    {
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "neuter",
        "degree": null
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "feminine",
        "degree": null
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "masculine",
        "degree": null
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": null,
        "degree": null
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "feminine",
        "degree": null
    },
    {
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "masculine",
        "degree": null
    },
    {
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": null,
        "degree": null
    },
    {
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": "feminine",
        "degree": null
    },
    {
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "feminine",
        "degree": "superlative"
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "masculine",
        "degree": null
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": null,
        "degree": null
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "neuter",
        "degree": null
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "feminine",
        "degree": null
    },
    {
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "neuter",
        "degree": null
    },
    {
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": "neuter",
        "degree": null
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": null,
        "degree": null
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "neuter",
        "degree": null
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": null,
        "degree": null
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "neuter",
        "degree": null
    },
    {
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "masculine",
        "degree": "comparative"
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": null,
        "degree": null
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "neuter",
        "degree": "comparative"
    },
    {
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": null,
        "degree": null
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "feminine",
        "degree": "superlative"
    },
    {
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "masculine",
        "degree": "superlative"
    },
    {
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "neuter",
        "degree": "comparative"
    },
    {
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": "masculine",
        "degree": null
    },
    {
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": "neuter",
        "degree": null
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "masculine",
        "degree": "comparative"
    },
    {
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "feminine",
        "degree": "superlative"
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "neuter",
        "degree": "comparative"
    },
    {
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "neuter",
        "degree": "comparative"
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "neuter",
        "degree": "superlative"
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "masculine",
        "degree": "comparative"
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "masculine",
        "degree": "superlative"
    },
    {
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "feminine",
        "degree": "comparative"
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "masculine",
        "degree": "superlative"
    },
    {
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": "masculine",
        "degree": "superlative"
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "neuter",
        "degree": "comparative"
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "feminine",
        "degree": "comparative"
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "neuter",
        "degree": "superlative"
    },
    {
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "masculine",
        "degree": "comparative"
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "neuter",
        "degree": "superlative"
    },
    {
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": "feminine",
        "degree": null
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "feminine",
        "degree": "comparative"
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "masculine",
        "degree": "comparative"
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "neuter",
        "degree": "superlative"
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "masculine",
        "degree": "superlative"
    },
    {
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "feminine",
        "degree": "comparative"
    },
    {
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "feminine",
        "degree": "superlative"
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "masculine",
        "degree": "comparative"
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "neuter",
        "degree": "superlative"
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "masculine",
        "degree": "comparative"
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "feminine",
        "degree": "comparative"
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "feminine",
        "degree": "comparative"
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "masculine",
        "degree": "comparative"
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "feminine",
        "degree": "comparative"
    },
    {
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "neuter",
        "degree": "superlative"
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "neuter",
        "degree": "comparative"
    },
    {
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": "masculine",
        "degree": "comparative"
    },
    {
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "feminine",
        "degree": "superlative"
    }
];

export const NT_VERBS: SimpleStringLookup[] = [
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "3rd",
        "tense": "imperfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "infinitive",
        "grammatical_case": null,
        "grammatical_number": null,
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "passive",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "future",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "future",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "future",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "perfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "passive",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "3rd",
        "tense": "future",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": "1st",
        "tense": "aorist",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "3rd",
        "tense": "imperfect",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "perfect",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "active",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "active",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "aorist",
        "voice": "active",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "active",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "active",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "infinitive",
        "grammatical_case": null,
        "grammatical_number": null,
        "gender": null
    },
    {
        "person": "1st",
        "tense": "aorist",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "infinitive",
        "grammatical_case": null,
        "grammatical_number": null,
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "middle",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "perfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": "3rd",
        "tense": "future",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "active",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "imperfect",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": "1st",
        "tense": "present",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "present",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "middle",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "active",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "future",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "imperfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": "3rd",
        "tense": "future",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "future",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "active",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "middle",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "infinitive",
        "grammatical_case": null,
        "grammatical_number": null,
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "active",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "active",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "middle",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "active",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "passive",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "future",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "active",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "infinitive",
        "grammatical_case": null,
        "grammatical_number": null,
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "middle",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "future",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "passive",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "active",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "middle",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "infinitive",
        "grammatical_case": null,
        "grammatical_number": null,
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "middle",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "middle",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "passive",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "passive",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "active",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "aorist",
        "voice": "active",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "aorist",
        "voice": "middle",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "future",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "future",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "perfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "active",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "pluperfect",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "1st",
        "tense": "present",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "2nd",
        "tense": "perfect",
        "voice": "active",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "3rd",
        "tense": "imperfect",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": "1st",
        "tense": "aorist",
        "voice": "middle",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "future",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "present",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "passive",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "middle",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": "1st",
        "tense": "future",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": "2nd",
        "tense": "future",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "middle",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "pluperfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": "3rd",
        "tense": "pluperfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "pluperfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": "2nd",
        "tense": "perfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": "1st",
        "tense": "aorist",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "middle",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": "1st",
        "tense": "aorist",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "perfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": "1st",
        "tense": "perfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": "1st",
        "tense": "imperfect",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "passive",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "active",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": "2nd",
        "tense": "imperfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "pluperfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "aorist",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "imperfect",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "1st",
        "tense": "present",
        "voice": "active",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "present",
        "voice": "active",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "1st",
        "tense": "future",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "future",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": "1st",
        "tense": "present",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "passive",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "perfect",
        "voice": "passive",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "infinitive",
        "grammatical_case": null,
        "grammatical_number": null,
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": "2nd",
        "tense": "imperfect",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "imperfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "active",
        "mood": "optative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "imperfect",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "active",
        "mood": "optative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "middle",
        "mood": "optative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": "2nd",
        "tense": "imperfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": "3rd",
        "tense": "perfect",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "active",
        "mood": "optative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "passive",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "middle",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "1st",
        "tense": "imperfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "infinitive",
        "grammatical_case": null,
        "grammatical_number": null,
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": "2nd",
        "tense": "perfect",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": "1st",
        "tense": "aorist",
        "voice": "passive",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "aorist",
        "voice": "passive",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "active",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "middle",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "middle",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "aorist",
        "voice": "middle",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "future",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": "1st",
        "tense": "aorist",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "pluperfect",
        "voice": "active",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "perfect",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": "1st",
        "tense": "present",
        "voice": "middle",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": "1st",
        "tense": "present",
        "voice": "middle",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "future",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "perfect",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "perfect",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "pluperfect",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "perfect",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "passive",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "perfect",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "future",
        "voice": "active",
        "mood": "infinitive",
        "grammatical_case": null,
        "grammatical_number": null,
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": "1st",
        "tense": "present",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "1st",
        "tense": "present",
        "voice": "middle",
        "mood": "optative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "imperfect",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "future",
        "voice": "middle",
        "mood": "infinitive",
        "grammatical_case": null,
        "grammatical_number": null,
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": "2nd",
        "tense": "perfect",
        "voice": "middle",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "future",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "active",
        "mood": "optative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "perfect",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "middle",
        "mood": "optative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "aorist",
        "voice": "middle",
        "mood": "optative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "pluperfect",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "masculine"
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "middle",
        "mood": "optative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "imperfect",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": "1st",
        "tense": "future",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "passive",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": "1st",
        "tense": "imperfect",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": "1st",
        "tense": "perfect",
        "voice": "active",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "perfect",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "imperfect",
        "voice": "passive",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "perfect",
        "voice": "active",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "passive",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "3rd",
        "tense": "present",
        "voice": "passive",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "passive",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "accusative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": "1st",
        "tense": "present",
        "voice": "passive",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": "2nd",
        "tense": "perfect",
        "voice": "active",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "passive",
        "mood": "optative",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "present",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": "2nd",
        "tense": "perfect",
        "voice": "active",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "singular",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "future",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": "1st",
        "tense": "present",
        "voice": "passive",
        "mood": "subjunctive",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "present",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": null,
        "tense": "future",
        "voice": "active",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "plural",
        "gender": "masculine"
    },
    {
        "person": "3rd",
        "tense": "aorist",
        "voice": "middle",
        "mood": "imperative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "passive",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": "2nd",
        "tense": "present",
        "voice": "active",
        "mood": "optative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "middle",
        "mood": "infinitive",
        "grammatical_case": null,
        "grammatical_number": null,
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "genitive",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "aorist",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "neuter"
    },
    {
        "person": "3rd",
        "tense": "perfect",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": "1st",
        "tense": "perfect",
        "voice": "middle",
        "mood": "indicative",
        "grammatical_case": null,
        "grammatical_number": "plural",
        "gender": null
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "nominative",
        "grammatical_number": "singular",
        "gender": "feminine"
    },
    {
        "person": null,
        "tense": "perfect",
        "voice": "middle",
        "mood": "participle",
        "grammatical_case": "dative",
        "grammatical_number": "plural",
        "gender": "masculine"
    }
];

export const OT_NOUNS: SimpleStringLookup[] = [
    {
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "sg",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "pl",
        "gn": "m",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "sg",
        "gn": "unknown",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "sg",
        "gn": "m",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "du",
        "gn": "unknown",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "sg",
        "gn": "f",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "pl",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "pl",
        "gn": "f",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "du",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "sg",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "sg",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "nu": "du",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "du",
        "gn": "f",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "du",
        "gn": "f",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "du",
        "gn": "f",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "pl",
        "gn": "m",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "sg",
        "gn": "unknown",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "du",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "sg",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "sg",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "nu": "du",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "nu": "pl",
        "gn": "f",
        "st": "NA",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "sg",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "du",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "sg",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "du",
        "gn": "f",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "du",
        "gn": "f",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "du",
        "gn": "f",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "sg",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "du",
        "gn": "f",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "du",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "du",
        "gn": "m",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "sg",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "nu": "du",
        "gn": "f",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "nu": "du",
        "gn": "f",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "nu": "sg",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "du",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "du",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "sg",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "nu": "sg",
        "gn": "f",
        "st": "e",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "nu": "sg",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "nu": "du",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "du",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "du",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "unknown",
        "gn": "unknown",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "nu": "du",
        "gn": "m",
        "st": "c",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "du",
        "gn": "f",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "nu": "du",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "nu": "du",
        "gn": "f",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "nu": "du",
        "gn": "m",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "pl",
        "prs_gn": "unknown"
    },
    {
        "nu": "du",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "sg",
        "prs_gn": "m"
    },
    {
        "nu": "du",
        "gn": "m",
        "st": "a",
        "prs_ps": "p1",
        "prs_nu": "sg",
        "prs_gn": "unknown"
    },
    {
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "du",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "pl",
        "gn": "m",
        "st": "e",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "nu": "pl",
        "gn": "f",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "nu": "sg",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "nu": "sg",
        "gn": "f",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "nu": "du",
        "gn": "m",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "nu": "du",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "sg",
        "prs_gn": "f"
    },
    {
        "nu": "du",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "nu": "pl",
        "gn": "m",
        "st": "a",
        "prs_ps": "p2",
        "prs_nu": "pl",
        "prs_gn": "f"
    },
    {
        "nu": "unknown",
        "gn": "unknown",
        "st": "a",
        "prs_ps": "p3",
        "prs_nu": "pl",
        "prs_gn": "m"
    },
    {
        "nu": "sg",
        "gn": "m",
        "st": "e",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "pl",
        "gn": "f",
        "st": "e",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "du",
        "gn": "f",
        "st": "e",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    },
    {
        "nu": "sg",
        "gn": "unknown",
        "st": "e",
        "prs_ps": "NA",
        "prs_nu": "NA",
        "prs_gn": "NA"
    }
];